import { Box } from '@mui/material';
import { ReactNode } from 'react';

type PropsType = {
  children?: ReactNode;
};

export const ReportDatasetSelectorParamsLayout = (props: PropsType) => {
  const { children } = props;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      {children}
    </Box>
  );
};
